/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  Alert, Box, Button, LinearProgress, MenuItem, Pagination, Select, Snackbar, Stack, TextField,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { ExpandMoreRounded, Search } from '@mui/icons-material';
import Elements from '../../../Elements';
import ROUTES from '../../../../Configs/routes';
import { getAdmin } from '../../../../Redux/Models/admin';
import { OverviewCard } from '../Overview/Overview';
import Images from '../../../../Configs/images';
// import ROUTES from '../../../../Configs/routes';

export default function AllAdmins({
  classes, admins, isLoading, currentPage = 1, totalPage = 1, adminOverview,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { devId } = useParams();

  const [keyword, setKeyword] = useState('');
  const [reqStatus, setStatus] = useState('all');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sort, setSort] = useState('Newest');

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getData = () => {
    dispatch(getAdmin({
      page, limit, sort, keyword,
    }));
  };

  useEffect(() => {
    getData();
  }, [page, limit, sort]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (page === 1) {
        getData();
      } else {
        setPage(1);
      }
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [keyword]);

  return (
    <Elements.AdminPageBase>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className={classes.root}>

        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box fontSize={20}>
            <strong>Admin</strong>
          </Box>
          <Box display="flex" alignItems="center" gap={3}>
            {/* <Box
              display="flex"
              alignItems="center"
              gap={1}
              py={1}
              px={2}
              bgcolor="#FDFDFD"
              borderRadius="10px"
              border="1px solid #E5E5E5"
              className="link"
              fontSize={14}
            >
              <img src={Images.Download} alt="download" height="20" width="20" />
              Download Order Report
            </Box> */}
            <Button className="btn-contained" size="small" sx={{ px: 2 }} onClick={() => navigate(`${ROUTES.admins()}/create`)}>Add New Admin</Button>
          </Box>
        </Box>

        <Box mt={3} borderRadius="10px" bgcolor="#FDFDFD" p={2}>
          <Box className="weight-600">Admins Overview</Box>
          <Stack direction="row" spacing={2} mt={2}>
            <OverviewCard
              title="Total Overall Admins"
              value={adminOverview.total_admin}
              percentage={-1}
            />
            <OverviewCard
              title="Total Super Admin"
              value={adminOverview.total_management_admin}
              percentage={-1}
            />
            <OverviewCard
              title="Total Warehouse Manager"
              value={adminOverview.total_warehouse_manager}
              percentage={-1}
            />
          </Stack>
        </Box>

        <Box mt={2} className="flex gap-16 space-between">
          <Box display="flex" gap={1}>
            <Select
              select
              size="small"
              value={sort}
              onChange={({ target }) => setSort(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value="Oldest">Oldest</MenuItem>
              <MenuItem value="Newest">Newest</MenuItem>
            </Select>
            <Select
              select
              value={reqStatus}
              size="small"
              onChange={({ target }) => setStatus(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value="all">All status</MenuItem>
            </Select>
          </Box>
          <Box display="flex" gap={2}>
            <Select
              select
              size="small"
              value={limit}
              onChange={({ target }) => setLimit(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value={10}>10 List</MenuItem>
              <MenuItem value={20}>20 List</MenuItem>
              <MenuItem value={50}>50 List</MenuItem>
            </Select>
            <TextField
              placeholder="Search by keyword"
              size="small"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              sx={{
                ' .MuiInputBase-root': {
                  bgcolor: '#fff',
                },
              }}
              InputProps={{
                startAdornment: (<Search fontSize="small" sx={{ mr: 1, color: '#D4D4D4' }} />),
              }}
            />
          </Box>
        </Box>

        <Box display="flex" justifyContent="space-between" mt={2}>
          <Box fontSize={12} color="#586479">
            <strong>{admins.length}</strong>
            {' '}
            admins
          </Box>
          <Pagination
            count={totalPage}
            variant="outlined"
            shape="rounded"
            size="small"
            page={!isLoading ? currentPage : page}
            siblingCount={0}
            onChange={(e, newPage) => setPage(newPage)}
          />
        </Box>

        {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}

        <div className="mt-3">
          <table>
            <thead>
              <tr style={{ background: '#2E3C40' }}>
                <td className="white">Admin ID</td>
                <td className="white">Name</td>
                <td className="white">Phone number</td>
                <td className="white">Type</td>
                <td className="white" colSpan={2}>Join date</td>
              </tr>
            </thead>
            <tbody>
              {admins.map((admin) => (
                <AdminItem admin={admin} />
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </Elements.AdminPageBase>
  );
}

function AdminItem({ admin }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <tr key={admin.id}>
      <td>
        <Link to={`${ROUTES.admins()}/detail/${admin.id}`} className="primary-green">
          {admin.id?.slice(0, 5)}
          ...
        </Link>

      </td>
      <td>{admin.name}</td>
      <td>{admin.phone_number}</td>
      <td>{admin.admin_type}</td>
      <td>{moment(new Date(admin.join_date)).format('DD MMM YYYY, HH.mm')}</td>
    </tr>
  );
}
